import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalQuestionsCategorySlice = createSlice({
  name: "editModalQuestionsCategory",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalQuestionsCategorySlice.actions;

export default editModalQuestionsCategorySlice.reducer;